import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, compose, applyMiddleware } from "redux";
import { Provider } from "react-redux";
import createSagaMiddleware from 'redux-saga';
import reducer from "./reducers";
import rootSaga from './sagas';
import App from './layouts/app';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Shoot from "./components/catalog/shoot";
var sagaMiddleware = createSagaMiddleware();
var middlewares = [sagaMiddleware];
var enhancer = process.env.NODE_ENV === 'production'
    ? compose(applyMiddleware.apply(void 0, middlewares))
    : compose(applyMiddleware.apply(void 0, middlewares), typeof window.__REDUX_DEVTOOLS_EXTENSION__ !== 'undefined'
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : function (f) { return f; });
var store = createStore(reducer, enhancer);
sagaMiddleware.run(rootSaga);
ReactDOM.render(React.createElement(Provider, { store: store },
    React.createElement(BrowserRouter, null,
        React.createElement(Switch, null,
            React.createElement(Route, { path: "/detail/spec/:item_id/:idx_b_manager", component: Shoot }),
            React.createElement(Route, { path: "*", component: App })))), document.querySelector('#wrap'));



//////////////////
// WEBPACK FOOTER
// ./src/detail/index.tsx
// module id = 114
// module chunks = 0